module.exports = __webpack_public_path__ + "img/apidays-live-hk-color.e1b62804.png";